import { insights, pageAt, pageTitle } from "./content";
import { routes } from "./data/site";
import AboutPage from "./pages/AboutPage";
import ArticlePage from "./pages/ArticlePage";
import CaseStudyPage from "./pages/CaseStudyPage";
import JobPage from "./pages/JobPage";
import TeamProfilePage from "./pages/TeamProfilePage";
import { articleKind } from "./lib/article-kind";
import CareersPage from "./pages/CareersPage";
import { BookingPage, ContactPage } from "./pages/contact/ContactPage";
import HomePage from "./pages/home/HomePage";
import ListingPage from "./pages/ListingPage";
import NotFoundPage from "./pages/NotFoundPage";
import ResourcePage from "./pages/ResourcePage";
import ResultsPage from "./pages/ResultsPage";
import ServicesPage from "./pages/ServicesPage";

// Legacy per-person calendar pages share the booking layout.
const bookingPaths = [
  routes.booking,
  "/jordans-calendar-page/",
  "/bills-calendar-page/",
];
const archivePath = /^\/(tag|author|category)\//;

/** Generic captured pages, by kind (see lib/article-kind.js). */
const articlePages = {
  case: CaseStudyPage,
  team: TeamProfilePage,
  career: JobPage,
  insight: ArticlePage,
};

/**
 * The view for a normalized route path. Specific layouts first; any other
 * captured page renders as an article; unknown paths get the 404 view.
 */
export function viewFor(path) {
  const page = pageAt(path);

  if (path === routes.home || path === "/home/") return <HomePage />;
  // "/case-studies-2/" is the insights archive, so it must be matched first.
  if (path.startsWith(routes.insights))
    return <ListingPage kind="Insight" items={insights} />;
  if (path.startsWith(routes.caseStudies)) return <ResultsPage />;
  if (path === routes.about) return <AboutPage page={page} />;
  if (path === routes.services || path === "/mobile/")
    return <ServicesPage page={pageAt(routes.services)} />;
  if (path === routes.careers) return <CareersPage />;
  if (path === routes.contact) return <ContactPage />;
  if (bookingPaths.includes(path)) return <BookingPage page={page} />;
  // Covers both the e-book page and its legacy "-download" twin.
  if (path.startsWith(routes.ebook.replace(/\/$/, ""))) return <ResourcePage />;
  if (archivePath.test(path))
    return (
      <ListingPage
        kind="Insight"
        items={page?.cards?.length ? page.cards : insights}
        title={pageTitle(page)}
        path={path}
      />
    );
  if (page) {
    const View = articlePages[articleKind(path)];
    return <View page={page} path={path} />;
  }
  return <NotFoundPage />;
}
